module.exports = __webpack_public_path__ + "play_icon.svg?f73a2970fcf7540f8a93a96b90c613ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play_icon.svg
// module id = 33
// module chunks = 0